export const environment = {
  production: true,
  configFile: 'assets/config/config.prod.sbs.json',
  apiPath: 'https://stepbystep-api2.healthyvirtuoso.com/backOffice',
  webapp: 'https://stepbystep-web.healthyvirtuoso.com'
};
